import { DASHBOARD_MESSAGES } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  DASHBOARD_CHART_TYPES,
  GENERAL_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import store from "@/store";
import { Http } from "@status/codes";
import { cloneDeep } from "lodash";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  DATA_TYPE,
  SPECIAL_FIELDS,
  SEE_BY_LIST
} from "../../constants/DashboardTemplatesConstants";
import { CollectionFilter } from "../../models/CollectionFilter";
import { CollectionSection } from "../../models/CollectionSection";
import { Field } from "../../models/Field";
import { FilterItemOfQuery } from "../../models/FilterItemOfQuery";
import { FilterOfCollection } from "../../models/FilterOfCollection";
import { IndicatorOrTag } from "../../models/IndicatorOrTag";
import { PropertiesChart } from "../../models/PropertiesChart";
import { Query } from "../../models/Query";
import {
  EventChart,
  SectionOfDashboard
} from "../../models/SectionOfDashboard";
import { BqDashboardService } from "../../services/BqDashboardService";
import {
  buildAndExecuteQuery,
  buildFilters,
  fixQuery,
  prepareData
} from "../../Utils";
import Charts from "../Charts/Charts.vue";
import ConfigureGraphCollection from "../ConfigureGraphCollection/ConfigureGraphCollection.vue";
import DashboardFilterGroup from "../DashboardFilterGroup/DashboardFilterGroup.vue";
@Component({
  name: "CollectionOfSection",
  components: {
    ConfigureGraphCollection,
    DynamicSelect,
    DashboardFilterGroup,
    Charts,
    EmptyState
  },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      eventChart: "getEventChart",
      triggerQuery: "getTriggerQuery"
    })
  }
})
export default class CollectionOfSection extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;
  @Prop() indexCollectionFilter!: number;
  @Prop() indexSectionOfDashboard!: number;
  @Prop() collectionFilter!: CollectionFilter;
  @Prop() collectionsOptions!: CollectionSection[];
  @Prop() newCollectionWasDeleted!: DynamicSelectData;
  @Prop() collectionsUpdate!: null;

  triggerQuery!: {
    trigger: number;
    indexSectionOfDashboard: number;
    indexCollectionFilter: number;
  };
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  eventChart!: EventChart;

  filters: FilterOfCollection[] = [];
  collectionField = [] as DynamicSelectData[];
  collectionsOptionsConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    required: true,
    hideDetails: false
  };
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  chartOptions = {};
  refreshFilters = 0;
  showDialogConfigChart = false;
  EMPTY_STATE_HEADER = DASHBOARD_MESSAGES.NO_RESULTS;
  EMPTY_STATE_PARAGRAPH = DASHBOARD_MESSAGES.NOT_FOUND;
  groupBy = [] as DynamicSelectData[];
  seeBy = [] as DynamicSelectData[];
  chartName = "";
  showCharts = false;
  firstQueryExecuted = false;
  foundData = true;
  showSeeBy = false;
  searching = false;
  chartType = "";
  reloadChartTypeMenu = 0;
  chartColor = { hex: "" };

  propertiesToChart: PropertiesChart = {
    indexSectionOfDashboard: this.indexSectionOfDashboard,
    indexCollectionFilter: this.indexCollectionFilter,
    groupBy: this.groupBy,
    chartType: this.chartType,
    chartColor: this.chartColor
  };
  changeCollectionField = false;
  rangeSize: number | null = null;
  showLoadingBar = false;
  specialCaseInForms = false;
  specialCaseInFormsGroupBy = false;
  mounted() {
    this.preloadData();
  }
  preloadData() {
    this.onSpecialFieldSelected(false);
    const collectionFilter = cloneDeep(
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter
      ]
    );
    this.collectionField = collectionFilter.collection;

    this.onNewCollectionWasAddedOrDeletedChange();
    this.chartName = collectionFilter.chartName;
    this.filters = cloneDeep(this.collectionFilter.filters);

    this.chartColor = { hex: collectionFilter.chartColor as string };

    this.chartType = collectionFilter.chartType;

    const collection = this.collectionsOptions.find(
      collection => collection.id == collectionFilter.collection[0].id
    );
    const fields = collection?.fields!?.map(item => {
      return { id: item.field, name: item.visualField, type: item.type };
    }) as DynamicSelectData[];

    if (
      !collectionFilter.query ||
      Object.keys(collectionFilter.query).length === 0
    )
      return;
    const groupBy =
      fields?.filter(option =>
        (collectionFilter.groupBy as string[]).includes(option.id)
      ) || [];
    const renderChart = groupBy.length == collectionFilter.groupBy?.length;
    this.groupBy = this.sortGroupBy(groupBy);
    this.seeBy =
      cloneDeep(SEE_BY_LIST).filter(
        option => option.id == (collectionFilter.seeBy as DynamicSelectData).id
      ) || [];

    this.rangeSize = collectionFilter.rangeSize;

    const allFiltersOfSection = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections.flatMap(collection => collection.filters);

    collectionFilter.query = fixQuery(
      collectionFilter.query as Query,
      allFiltersOfSection as FilterItemOfQuery[]
    );

    this.makeQueryWhenIsPreloading(
      collectionFilter.query as Query,
      renderChart
    );
  }

  get keyGroup(): string {
    return `${this.collectionField[0]?.id}`;
  }

  @Watch("indexCollectionFilter")
  onIndexCollectionFilterChange() {
    // Re-cargar los datos con el nuevo índice
    this.preloadData();
  }
  @Watch("collectionFilter", { deep: true })
  onChanngeColelctionDeep() {
    if (this.collectionFilter.chartType != this.propertiesToChart.chartType) {
      this.chartType = this.collectionFilter.chartType;
      this.propertiesToChart.chartType = this.collectionFilter.chartType;
    }
  }

  @Watch("triggerQuery")
  onTriggerQueryChange() {
    if (
      this.triggerQuery.indexSectionOfDashboard !=
        this.indexSectionOfDashboard ||
      this.triggerQuery.indexCollectionFilter != this.indexCollectionFilter
    ) {
      return;
    }
    this.changeCollectionField = true;
    this.groupBy = [];
    this.seeBy = [];
    this.rangeSize = null;
    this.makeQuery();
  }

  updateCollection() {
    const groupBy =
      (this.collectionFilter.groupBy as string[])
        .map((groupById: string) => {
          const field = this.collectionField[0]?.fields?.find(
            (option: Field) => option.field === groupById
          );
          if (field) {
            return {
              id: field.field,
              name: field.visualField,
              type: field.type
            };
          }
          return null;
        })
        .filter(item => item !== null) || [];

    this.groupBy = this.sortGroupBy(groupBy as DynamicSelectData[]);
    store.commit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_GROUP_BY, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      groupBy: this.groupBy
    });
    if (this.groupBy.length > 0) {
      this.renderChartWhenIsPreloading();
    }
  }

  @Watch("collectionFilter")
  onCollectionFilterChange() {
    this.collectionField = cloneDeep(this.collectionFilter.collection);
    const copySectionsOfDashboardStore = cloneDeep(
      this.sectionsOfDashboardStore
    );

    this.groupBy =
      (copySectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter
      ].groupBy as DynamicSelectData[]) || [];
    this.seeBy =
      (copySectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter
      ].seeBy as DynamicSelectData[]) || [];
    this.filters = copySectionsOfDashboardStore[this.indexSectionOfDashboard]
      .collections[this.indexCollectionFilter].filters as FilterOfCollection[];
    this.refreshFilters = this.refreshFilters + 1;
    this.makeQuery();
  }

  onCollectionFieldChange() {
    this.$emit("onCollectionFieldChange", this.collectionField);
    store.commit(
      DASHBOARD_TEMPLATE_EVENTS.QUITE_COLLECTION_ITEM_OPTION_AND_PUT_IN_COLLECTION,
      {
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollectionFilter: this.indexCollectionFilter,
        collection: this.collectionField
      }
    );
    store.commit(DASHBOARD_TEMPLATE_EVENTS.CHANGE_COLLECTION_FIELD, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter
    });
    this.showCharts = false;
    this.groupBy = [];
    this.seeBy = [];
    this.rangeSize = null;
    this.chartName = "";
    this.chartColor = { hex: "" };
    this.chartType = "";
    this.filters = [];
  }

  updateConfigChart(data: any) {
    this.chartName = data.chartName;
    this.groupBy = this.sortGroupBy(data.groupBy as DynamicSelectData[]);
    this.seeBy = data.seeBy;
    this.rangeSize = data.rangeSize;
    this.chartColor = data.chartColor;
    this.saveConfigChart();
  }

  sortGroupBy(groupBy: DynamicSelectData[]) {
    return groupBy.sort((a: DynamicSelectData, b: DynamicSelectData) => {
      const aIsTimestamp =
        typeof a !== "string" && a.type === DATA_TYPE.TIME_STAMP;
      const bIsTimestamp =
        typeof b !== "string" && b.type === DATA_TYPE.TIME_STAMP;
      return aIsTimestamp && !bIsTimestamp
        ? -1
        : !aIsTimestamp && bIsTimestamp
        ? 1
        : 0;
    });
  }

  saveConfigChart() {
    if (this.validateGroupBy()) {
      return Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.CANT_GROUP_BY_DATE);
    }
    this.showDialogConfigChart = false;
    this.makeQuery();
  }

  validateGroupBy() {
    return (
      this.groupBy.filter(groupBy => groupBy.type == DATA_TYPE.TIME_STAMP)
        .length == 2
    );
  }

  deleteCollection() {
    if (
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections
        .length === 1
    ) {
      Snackbar.popWarning("Debe tener al menos una colección");
      return;
    }

    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_COLLECTION, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index: this.indexCollectionFilter
    });

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_COLLECTION_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      collection: this.collectionField[0]
    });
    this.$emit("deleteCollection", this.collectionField[0]);
  }

  sendDataToStoreReadyToChart(
    xAxis: [],
    data: [],
    groups: {},
    indexCollection: number,
    groupBy: DynamicSelectData[],
    seeBy: DynamicSelectData[],
    rangeSize: number | null,
    idQuery: string
  ) {
    const prepareDataToStore = prepareData(
      this.chartName,
      xAxis,
      data,
      groups,
      indexCollection,
      groupBy,
      rangeSize,
      seeBy,
      this.indexSectionOfDashboard,
      this.chartColor as { hex: "" },
      this.indexCollectionFilter,
      idQuery
    );

    store.commit(
      DASHBOARD_TEMPLATE_EVENTS.SET_CONFIG_CHART,
      prepareDataToStore
    );
  }

  configChart() {
    this.showDialogConfigChart = true;
  }

  async makeQuery(editMode?: boolean) {
    this.showCharts = false;
    let filters: FilterItemOfQuery[] = [];
    const collections = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections;
    filters = buildFilters(
      collections,
      filters,
      this.indexCollectionFilter,
      this.sectionsOfDashboardStore,
      this.indexSectionOfDashboard,
      editMode || false
    );

    this.buildEveryQuery(collections, filters);
    this.updateTagsQueries(
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].tags,
      filters
    );
  }

  async updateTagsQueries(
    tags: IndicatorOrTag[],
    filters: FilterItemOfQuery[]
  ) {
    try {
      for (const [index, tag] of tags.entries()) {
        const copyOfTag = cloneDeep(tag);
        if (!copyOfTag.query) continue;
        const newFilters = filters.map((e: FilterItemOfQuery) => {
          if (
            e.view === "forms" &&
            e.field === "formTemplate" &&
            Array.isArray(tag.selectorFieldToOperate) &&
            tag.selectorFieldToOperate.length > 0
          ) {
            const value = e.value as any[];
            const newValue =
              Array.isArray(value) && value.length > 0
                ? value.filter(
                    (e: any) => e == tag.fieldToOperate![0].formTemplate
                  )
                : value;
            return {
              ...e,
              value: newValue
            };
          }
          return e;
        });
        copyOfTag.query.filters = newFilters;
        const dataToChartResponse = await this.bqDashboardService.getDataToChart(
          copyOfTag.query
        );

        if (dataToChartResponse.code !== Http.Found) {
          continue;
        }
        copyOfTag.value = Number(
          (Object.values(
            dataToChartResponse.data.result[0]
          )[0] as number).toFixed(2)
        );
        console.log("copyOfTag.value", copyOfTag.value);
        store.commit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG, {
          indexSectionOfDashboard: this.indexSectionOfDashboard,
          index: index,
          tag: copyOfTag
        });
      }
    } catch (error) {
      console.error("error", error);
    }
  }

  buildEveryQuery(
    collections: CollectionFilter[],
    filters: FilterItemOfQuery[]
  ) {
    for (const [indexCollection, collection] of collections.entries()) {
      if (
        this.changeCollectionField &&
        collection.collection[0].id == this.collectionField[0].id
      ) {
        this.changeCollectionField = false;
        continue;
      }
      this.manageAsynQuerys(collection, filters, indexCollection);
    }
  }

  async manageAsynQuerys(
    collection: CollectionFilter,
    filters: FilterItemOfQuery[],
    indexCollection: number
  ) {
    try {
      const query = buildAndExecuteQuery(
        collection,
        filters,
        indexCollection,
        this.indexCollectionFilter,
        this.groupBy,
        this.indexCollectionFilter == indexCollection
          ? this.rangeSize
          : collection.rangeSize,
        this.seeBy
      );

      if (!query) return;

      store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_QUERY, {
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollectionFilter: indexCollection,
        query: query
      });
      store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FETCH_DATA, true);
      this.$emit(DASHBOARD_TEMPLATE_EVENTS.SHOW_LOADING_BAR, true);
      this.showLoadingBar = true;
      const dataToChartResponse = await this.bqDashboardService.getDataToChart(
        query
      );
      store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FETCH_DATA, false);
      this.$emit(DASHBOARD_TEMPLATE_EVENTS.SHOW_LOADING_BAR, false);
      this.showLoadingBar = false;
      if (dataToChartResponse.code !== Http.Found) {
        this.foundData = false;
        if (this.indexCollectionFilter == indexCollection) {
          this.showCharts = false;
        }
        store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_CONFIG_CHART, {
          notFound: true,
          indexSectionOfDashboard: this.indexSectionOfDashboard,
          indexCollectionFilter: indexCollection
        });
      }
      this.foundData = true;

      if (this.indexCollectionFilter == indexCollection) {
        this.propertiesToChart = {
          indexSectionOfDashboard: this.indexSectionOfDashboard,
          indexCollectionFilter: this.indexCollectionFilter,
          groupBy: this.groupBy,
          chartType: this.chartType,
          chartColor: this.chartColor
        };
        this.showCharts = true;
      }

      this.onChartTypeChanged(this.chartType);

      this.sendDataToStoreReadyToChart(
        dataToChartResponse.data?.result?.xAxisValues || [],
        this.fixSeries(dataToChartResponse.data?.result?.series),
        dataToChartResponse.data?.result?.groups || {},
        indexCollection,
        this.indexCollectionFilter == indexCollection
          ? this.groupBy
          : (collection.groupBy as DynamicSelectData[]),
        this.indexCollectionFilter == indexCollection
          ? this.seeBy
          : (collection.seeBy as DynamicSelectData[]),
        this.indexCollectionFilter == indexCollection
          ? this.rangeSize
          : (collection.rangeSize as number | null),
        dataToChartResponse.data?.idQuery || ""
      );
    } catch (error) {
      Snackbar.popError("Error al hacer la consulta");
      store.commit("setFetchData", false);
    }
  }
  fixSeries(series: any[]): [] {
    if (series && series.length > 0) {
      return series.map(item => {
        return {
          ...item,
          name: item.name || "Ninguno(a)"
        };
      }) as [];
    }
    return [];
  }

  fixSeeBy(seeBy: DynamicSelectData[]) {
    if (seeBy && seeBy.length > 0) {
      return seeBy[0].id;
    }
    return "";
  }

  async makeQueryWhenIsPreloading(query: Query, renderChart: boolean) {
    try {
      this.searching = true;
      const dataToChartResponse = await this.bqDashboardService.getDataToChart(
        query
      );
      this.searching = false;
      if (dataToChartResponse.code !== Http.Found) {
        this.foundData = false;
        this.showCharts = false;
        return;
      }
      this.foundData = true;
      if (renderChart) {
        this.renderChartWhenIsPreloading();
      }
      this.sendDataToStoreReadyToChart(
        dataToChartResponse.data.result.xAxisValues,
        dataToChartResponse.data.result.series,
        dataToChartResponse.data.result.groups,
        this.indexCollectionFilter,
        this.groupBy,
        this.seeBy,
        this.rangeSize,
        dataToChartResponse.data?.idQuery || ""
      );
    } catch (error) {
      // Error handling
    }
  }

  renderChartWhenIsPreloading() {
    this.propertiesToChart = {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      groupBy: this.groupBy,
      chartType: this.chartType,
      chartColor: this.chartColor
    };
    this.onChartTypeChanged(this.chartType);
    this.showCharts = true;
  }

  fixGroupBy(
    groupBy: (DynamicSelectData | string)[],
    collection: CollectionFilter
  ) {
    if (!Array.isArray(groupBy) || !collection?.collection?.length) return [];
    return groupBy.map(item => ({
      view: collection.collection[0].id,
      field: typeof item === "string" ? item : item.id
    }));
  }

  @Watch("groupBy")
  onGroupByChange() {
    if (!this.groupBy) return;
    this.reloadChartTypeMenu++;
    if (
      this.groupBy.filter(groupBy => groupBy.type == DATA_TYPE.TIME_STAMP)
        .length > 0
    ) {
      this.showSeeBy = true;
      return;
    }
    this.showSeeBy = false;
  }

  cancelConfigChart() {
    this.showDialogConfigChart = false;
  }

  onChartTypeChanged(newChartType: string) {
    const listChartTypesForGroupBy = DASHBOARD_CHART_TYPES.filter(e =>
      this.groupBy.length > 1 ? e.stacked : !e.stacked
    ).map(e => e.value);
    if (!listChartTypesForGroupBy.includes(newChartType)) {
      newChartType = listChartTypesForGroupBy[0];
    }
    this.propertiesToChart = {
      ...this.propertiesToChart,
      chartType: newChartType
    };

    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_CHART_TYPE, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      chartType: newChartType
    });
  }

  @Watch("collectionsUpdate")
  onNewCollectionWasAddedOrDeletedChange() {
    const collectionsSelected = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections
      .map(item => item.collection[0].id)
      .filter(item => item !== this.collectionField[0].id);
    this.collectionsOptionsConfig.listAll = this.collectionsOptions.filter(
      item => !collectionsSelected.includes(item.id)
    );
  }

  get disabledGraph() {
    return !(
      Array.isArray(this.collectionField) && this.collectionField[0]?.id
    );
  }

  onSpecialFieldSelected(isSpecialField: boolean) {
    const collectionFilter = cloneDeep(
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections[
        this.indexCollectionFilter
      ]
    );

    if (
      collectionFilter.collection[0].id !== "forms" &&
      collectionFilter.collection[0].id !== "services"
    ) {
      return;
    }

    if (isSpecialField) {
      this.specialCaseInForms = true;
      return;
    }
    const hasSpecialField = collectionFilter.filters.some(filter => {
      if (Array.isArray(filter.field)) {
        return filter.field.some(f => SPECIAL_FIELDS.includes(f.id));
      }
      return (
        typeof filter.field === "string" &&
        SPECIAL_FIELDS.includes(filter.field)
      );
    });
    this.specialCaseInForms = hasSpecialField;
  }

  deleteChart() {
    this.showCharts = false;
    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_CHART, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter
    });
  }
}
